import {Injectable, Injector, Type} from '@angular/core';
import {Resource} from 'app/constants/resource';
import {DailyActivitySummaryResource} from 'app/blocks/resource/daily-activity-summary-resource';
import {Role} from 'app/blocks/model/role.model';
import {AsyncRequestResource} from 'app/blocks/resource/async-request-resource';
import {BackupResource} from 'app/blocks/resource/backup-resource';
import {BillingFrequencyTypeResource} from 'app/blocks/resource/billing-frequency-type-resource';
import {BinResource} from 'app/blocks/resource/bin-resource';
import {BinTypeResource} from 'app/blocks/resource/bin-type-resource';
import {BranchPaymentResource} from 'app/blocks/resource/branch-payment-resource';
import {BranchResource} from 'app/blocks/resource/branch-resource';
import {BranchTransactionResource} from 'app/blocks/resource/branch-transaction-resource';
import {BrandResource} from 'app/blocks/resource/brand-resource';
import {BudgetResource} from 'app/blocks/resource/budget-resource';
import {CatalogueResource} from 'app/blocks/resource/catalogue-resource';
import {CGSTCategoryResource} from 'app/blocks/resource/cgst-category-resource';
import {ClientSaleOrderResource} from 'app/blocks/resource/client-sale-order-resource';
import {CompanyResource} from 'app/blocks/resource/company-resource';
import {CountryResource} from 'app/blocks/resource/country-resource';
import {CreditClassResource} from 'app/blocks/resource/credit-class-resource';
import {CreditTermResource} from 'app/blocks/resource/credit-term-resource';
import {CurrencyResource} from 'app/blocks/resource/currency-resource';
import {CustomFieldGroupResource} from 'app/blocks/resource/custom-field-group-resource';
import {CustomFieldResource} from 'app/blocks/resource/custom-field-resource';
import {CustomPdfTemplateResource} from 'app/blocks/resource/custom-pdf-template-resource';
import {CustomerGroupResource} from 'app/blocks/resource/customer-group-resource';
import {CustomerResource} from 'app/blocks/resource/customer-resource';
import {CustomerSmsTextResource} from 'app/blocks/resource/customer-sms-text-resource';
import {CustomerStatusReasonGroupResource} from 'app/blocks/resource/customer-status-reason-group-resource';
import {CustomerStatusReasonResource} from 'app/blocks/resource/customer-status-reason-resource';
import {CustomerStatusResource} from 'app/blocks/resource/customer-status-resource';
import {DeliveryItemResource} from 'app/blocks/resource/delivery-item-resource';
import {DeliveryMethodResource} from 'app/blocks/resource/delivery-method-resource';
import {DeliveryOrderResource} from 'app/blocks/resource/delivery-order-resource';
import {DeliveryPackageResource} from 'app/blocks/resource/delivery-package-resource';
import {DeliveryPackageTypeResource} from 'app/blocks/resource/delivery-package-type-resource';
import {DeliveryPointMessageTypeResource} from 'app/blocks/resource/delivery-point-message-type-resource';
import {DeliveryPointResource} from 'app/blocks/resource/delivery-point-resource';
import {DepositItemResource} from 'app/blocks/resource/deposit-item-resource';
import {DunningMessageCodeResource} from 'app/blocks/resource/dunning-message-code-resource';
import {DurationPriceListResource} from 'app/blocks/resource/duration-price-list-resource';
import {DurationProductPriceInfoResource} from 'app/blocks/resource/duration-product-price-info-resource';
import {DynamicHeaderCodeResource} from 'app/blocks/resource/dynamic-header-code-resource';
import {EmployeeExpenseResource} from 'app/blocks/resource/employee-expense-resource';
import {EmployeeGroupResource} from 'app/blocks/resource/employee-group-resource';
import {EmployeeResource} from 'app/blocks/resource/employee-resource';
import {EquipmentResource} from 'app/blocks/resource/equipment-resource';
import {ExecutionResource} from 'app/blocks/resource/execution-resource';
import {ExpensePaymentMethodResource} from 'app/blocks/resource/expense-payment-method-resource';
import {ExpenseTypeResource} from 'app/blocks/resource/expense-type-resource';
import {FranchiseResource} from 'app/blocks/resource/franchise-resource';
import {FuelSurchargeGroupResource} from 'app/blocks/resource/fuel-surcharge-group-resource';
import {GctTaxCategoryResource} from 'app/blocks/resource/gct-tax-category-resource';
import {HandheldProfileResource} from 'app/blocks/resource/handheld-profile-resource';
import {IGSTCategoryResource} from 'app/blocks/resource/igst-category-resource';
import {IncomingInventoryResource} from 'app/blocks/resource/incoming-inventory-resource';
import {IntegrationMappingResource} from 'app/blocks/resource/integration-mapping-resource';
import {InventoryProductEntryResource} from 'app/blocks/resource/inventory-product-entry-resource';
import {InventoryReasonGroupResource} from 'app/blocks/resource/inventory-reason-group-resource';
import {InventoryReasonResource} from 'app/blocks/resource/inventory-reason-resource';
import {InvoiceResource} from 'app/blocks/resource/invoice-resource';
import {ListProductPriceResource} from 'app/blocks/resource/list-product-price-resource';
import {LoadOrderResource} from 'app/blocks/resource/load-order-resource';
import {MajorAccountCodeResource} from 'app/blocks/resource/major-account-code-resource';
import {OrderItemReasonResource} from 'app/blocks/resource/order-item-reason-resource';
import {OrderItemResource} from 'app/blocks/resource/order-item-resource';
import {OrderPriorityResource} from 'app/blocks/resource/order-priority-resource';
import {OrderRejectionCodeResource} from 'app/blocks/resource/order-rejection-code-resource';
import {OrderStatusReasonResource} from 'app/blocks/resource/order-status-reason-resource';
import {OrganisationResource} from 'app/blocks/resource/organisation.resource';
import {PackOrderResource} from 'app/blocks/resource/pack-order-resource';
import {PackagingResource} from 'app/blocks/resource/packaging-resource';
import {PaymentTypeResource} from 'app/blocks/resource/payment-type-resource';
import {PickOrderResource} from 'app/blocks/resource/pick-order-resource';
import {PresentationResource} from 'app/blocks/resource/presentation-resource';
import {PriceListResource} from 'app/blocks/resource/price-list-resource';
import {PriceListTypeResource} from 'app/blocks/resource/price-list-type-resource';
import {ProductAttributeTypeResource} from 'app/blocks/resource/product-attribute-type-resource';
import {ProductClassResource} from 'app/blocks/resource/product-class-resource';
import {ProductCostChangeResource} from 'app/blocks/resource/product-cost-change-resource';
import {ProductGroupResource} from 'app/blocks/resource/product-group-resource';
import {ProductListResource} from 'app/blocks/resource/product-list-resource';
import {ProductPackagingResource} from 'app/blocks/resource/product-packaging-resource';
import {ProductResource} from 'app/blocks/resource/product-resource';
import {ProductTaxCategoryResource} from 'app/blocks/resource/product-tax-category-resource';
import {ProfileResource} from 'app/blocks/resource/profile-resource';
import {PurchaseCreditNoteResource} from 'app/blocks/resource/purchase-credit-note-resource';
import {PurchaseOrderResource} from 'app/blocks/resource/purchase-order-resource';
import {PurchasePaymentResource} from 'app/blocks/resource/purchase-payment-resource';
import {CatalogueResourceGroupResource} from 'app/blocks/resource/resource-group-resource';
import {CatalogueResourceItemResource} from 'app/blocks/resource/resource-item-resource';
import {RestoreResource} from 'app/blocks/resource/restore-resource';
import {RoiVatCategoryResource} from 'app/blocks/resource/roi-vat-category-resource';
import {RouteMapSymbolResource} from 'app/blocks/resource/route-map-symbol-resource';
import {RouteResource} from 'app/blocks/resource/route-resource';
import {RouteTypeResource} from 'app/blocks/resource/route-type-resource';
import {SaleOrderResource} from 'app/blocks/resource/sale-order-resource';
import {SaleOrderTypeResource} from 'app/blocks/resource/sale-order-type-resource';
import {ServiceItemResource} from 'app/blocks/resource/service-item-resource';
import {ServicePriorityCodeResource} from 'app/blocks/resource/service-priority-code-resource';
import {SGSTCategoryResource} from 'app/blocks/resource/sgst-category-resource';
import {ShortfallReportResource} from 'app/blocks/resource/shortfall-report-resource';
import {SiteVisitSkipReasonsResource} from 'app/blocks/resource/site-visit-skip-reasons-resource';
import {StatementCodeResource} from 'app/blocks/resource/statement-code-resource';
import {StatementTypeResource} from 'app/blocks/resource/statement-type-resource';
import {StockChangeConditionResource} from 'app/blocks/resource/stock-change-condition-resource';
import {StopTypeResource} from 'app/blocks/resource/stop-type-resource';
import {SupplerGroupResource} from 'app/blocks/resource/supplier-group-resource';
import {SupplierPaymentTermResource} from 'app/blocks/resource/supplier-payment-term-resource';
import {SupplierResource} from 'app/blocks/resource/supplier-resource';
import {SurveyReportResource} from 'app/blocks/resource/survey-report-resource';
import {TenantResource} from 'app/blocks/resource/tenants-resource';
import {TrailerResource} from 'app/blocks/resource/trailer-resource';
import {TrailerTypeResource} from 'app/blocks/resource/trailer-type-resource';
import {UnitOfMeasureResource} from 'app/blocks/resource/unit-of-measure-resource';
import {UserResource} from 'app/blocks/resource/user-resource';
import {VehicleCheckListResource} from 'app/blocks/resource/vehicle-check-list-resource';
import {VehicleResource} from 'app/blocks/resource/vehicle-resource';
import {VehicleSkillResource} from 'app/blocks/resource/vehicle-skill';
import {VehicleTypeResource} from 'app/blocks/resource/vehicle-type-resource';
import {VehicleUnloadResource} from 'app/blocks/resource/vehicle-unload.resource';
import {WarehouseResource} from 'app/blocks/resource/warehouse-resource';
import {WarehouseTypeResource} from 'app/blocks/resource/warehouse-type-resource';
import {WorkshopResource} from 'app/blocks/resource/workshop-resource';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';
import {WarehouseTransferResource} from 'app/blocks/resource/warehouse-transfer-resource';
import {StandingOrderResource} from 'app/blocks/resource/standing-order-resource';
import {StandingLoadOrderResource} from 'app/blocks/resource/standing-load-order-resource';
import {CreditNoteResource} from 'app/blocks/resource/credit-note-resource';
import {AttributeWhitelistResource} from 'app/blocks/resource/attribute-whitelist-resource';
import {TerritoryResource} from 'app/blocks/resource/territory-resource';

@Injectable({
    providedIn: 'root'
})
export class EntityResource {
    public resourceFactory = new Map<Resource, Type<any>>();
    constructor(private _injector: Injector) {
        this.resourceFactory.set(Resource.DAILY_ACTIVITY_SUMMARIES, DailyActivitySummaryResource);
        this.resourceFactory.set(Resource.SUPPLIERS, SupplierResource);
        this.resourceFactory.set(Resource.ROLES, Role);
        this.resourceFactory.set(Resource.BRANCHES, BranchResource);
        this.resourceFactory.set(Resource.FRANCHISES, FranchiseResource);
        this.resourceFactory.set(Resource.COUNTRIES, CountryResource);
        this.resourceFactory.set(Resource.WAREHOUSES, WarehouseResource);
        this.resourceFactory.set(Resource.WORKSHOP, WorkshopResource);
        this.resourceFactory.set(Resource.WAREHOUSE_TYPES, WarehouseTypeResource);
        this.resourceFactory.set(Resource.COMPANIES, CompanyResource);
        this.resourceFactory.set(Resource.CURRENCIES, CurrencyResource);
        this.resourceFactory.set(Resource.MAJOR_ACCOUNT_CODES, MajorAccountCodeResource);
        this.resourceFactory.set(Resource.EMPLOYEES, EmployeeResource);
        this.resourceFactory.set(Resource.EMPLOYEE_GROUPS, EmployeeGroupResource);
        this.resourceFactory.set(Resource.STATEMENT_CODES, StatementCodeResource);
        this.resourceFactory.set(Resource.STATEMENT_TYPES, StatementTypeResource);
        this.resourceFactory.set(Resource.BILLING_FREQUENCY_TYPES, BillingFrequencyTypeResource);
        this.resourceFactory.set(Resource.DUNNING_MESSAGE_CODES, DunningMessageCodeResource);
        this.resourceFactory.set(Resource.CREDIT_CLASSES, CreditClassResource);
        this.resourceFactory.set(Resource.CREDIT_TERMS, CreditTermResource);
        this.resourceFactory.set(Resource.DELIVERY_POINTS, DeliveryPointResource);
        this.resourceFactory.set(Resource.DYNAMIC_HEADER_CODES, DynamicHeaderCodeResource);
        this.resourceFactory.set(Resource.STOP_TYPES, StopTypeResource);
        this.resourceFactory.set(Resource.CUSTOMERS, CustomerResource);
        this.resourceFactory.set(Resource.PAYMENT_TYPES, PaymentTypeResource);
        this.resourceFactory.set(Resource.CUSTOMER_STATUSES, CustomerStatusResource);
        this.resourceFactory.set(Resource.SERVICE_PRIORITY_CODES, ServicePriorityCodeResource);
        this.resourceFactory.set(Resource.CUSTOM_FIELD_GROUPS, CustomFieldGroupResource);
        this.resourceFactory.set(Resource.CUSTOM_FIELDS, CustomFieldResource);
        this.resourceFactory.set(Resource.CUSTOMER_STATUS_REASONS, CustomerStatusReasonResource);
        this.resourceFactory.set(Resource.CUSTOMER_STATUS_REASON_GROUPS, CustomerStatusReasonGroupResource);
        this.resourceFactory.set(Resource.CUSTOMER_GROUPS, CustomerGroupResource);
        this.resourceFactory.set(Resource.PRICE_LISTS, PriceListResource);
        this.resourceFactory.set(Resource.PRICE_LIST_TYPES, PriceListTypeResource);
        this.resourceFactory.set(Resource.DURATION_PRICE_LISTS, DurationPriceListResource);
        this.resourceFactory.set(Resource.LIST_PRODUCT_PRICES, ListProductPriceResource);
        this.resourceFactory.set(Resource.DELIVERY_POINT_MESSAGE_TYPES, DeliveryPointMessageTypeResource);
        this.resourceFactory.set(Resource.CUSTOMER_SMS_TEXTS, CustomerSmsTextResource);
        this.resourceFactory.set(Resource.TENANTS, TenantResource);
        this.resourceFactory.set(Resource.VEHICLE_UNLOADS, VehicleUnloadResource);
        this.resourceFactory.set(Resource.DEPOSIT_ITEMS, DepositItemResource);

        this.resourceFactory.set(Resource.PRODUCT_CLASSES, ProductClassResource);
        this.resourceFactory.set(Resource.PRODUCT_ATTRIBUTE_TYPES, ProductAttributeTypeResource);
        this.resourceFactory.set(Resource.PRODUCT_GROUPS, ProductGroupResource);
        this.resourceFactory.set(Resource.UNIT_OF_MEASURES, UnitOfMeasureResource);
        this.resourceFactory.set(Resource.PACKAGINGS, PackagingResource);
        this.resourceFactory.set(Resource.PRODUCT_PACKAGINGS, ProductPackagingResource);
        this.resourceFactory.set(Resource.PRODUCTS, ProductResource);
        this.resourceFactory.set(Resource.PRODUCT_LISTS, ProductListResource);
        this.resourceFactory.set(Resource.UK_VAT_RATES, ProductTaxCategoryResource);
        this.resourceFactory.set(Resource.ROI_VAT_RATES, RoiVatCategoryResource);
        this.resourceFactory.set(Resource.DURATION_PRODUCT_PRICE_INFOS, DurationProductPriceInfoResource);
        this.resourceFactory.set(Resource.DELIVERY_PACKAGE_TYPES, DeliveryPackageTypeResource);
        this.resourceFactory.set(Resource.DEPOSIT_ITEMS, DepositItemResource);

        this.resourceFactory.set(Resource.VEHICLES, VehicleResource);
        this.resourceFactory.set(Resource.VEHICLE_TYPES, VehicleTypeResource);
        this.resourceFactory.set(Resource.VEHICLE_SKILL, VehicleSkillResource);
        this.resourceFactory.set(Resource.TRAILERS, TrailerResource);
        this.resourceFactory.set(Resource.TRAILER_TYPES, TrailerTypeResource);
        this.resourceFactory.set(Resource.ROUTE_TYPES, RouteTypeResource);
        this.resourceFactory.set(Resource.ROUTE_MAP_SYMBOLS, RouteMapSymbolResource);
        this.resourceFactory.set(Resource.ROUTES, RouteResource);

        this.resourceFactory.set(Resource.SALE_ORDERS, SaleOrderResource);
        this.resourceFactory.set(Resource.CLIENT_SALE_ORDERS, ClientSaleOrderResource);
        this.resourceFactory.set(Resource.SALE_ORDER_TYPES, SaleOrderTypeResource);
        this.resourceFactory.set(Resource.DELIVERY_METHODS, DeliveryMethodResource);
        this.resourceFactory.set(Resource.ORDER_PRIORITIES, OrderPriorityResource);
        this.resourceFactory.set(Resource.PROFILES, ProfileResource);
        this.resourceFactory.set(Resource.ORDER_STATUS_REASONS, OrderStatusReasonResource);
        this.resourceFactory.set(Resource.ORDER_ITEMS, OrderItemResource);
        this.resourceFactory.set(Resource.ORDER_REJECTION_CODES, OrderRejectionCodeResource);
        this.resourceFactory.set(Resource.INCOMING_INVENTORIES, IncomingInventoryResource);
        this.resourceFactory.set(Resource.INVENTORY_PRODUCT_ENTRIES, InventoryProductEntryResource);
        this.resourceFactory.set(Resource.INVENTORY_REASONS, InventoryReasonResource);
        this.resourceFactory.set(Resource.INVENTORY_REASON_GROUPS, InventoryReasonGroupResource);
        this.resourceFactory.set(Resource.LOAD_ORDERS, LoadOrderResource);
        this.resourceFactory.set(Resource.DELIVERY_ITEMS, DeliveryItemResource);
        this.resourceFactory.set(Resource.DELIVERY_PACKAGES, DeliveryPackageResource);
        this.resourceFactory.set(Resource.PACK_ORDERS, PackOrderResource);
        this.resourceFactory.set(Resource.PICK_ORDERS, PickOrderResource);
        this.resourceFactory.set(Resource.ORDER_ITEM_REASONS, OrderItemReasonResource);
        this.resourceFactory.set(Resource.DELIVERY_ORDERS, DeliveryOrderResource);
        this.resourceFactory.set(Resource.SERVICE_ITEMS, ServiceItemResource);
        this.resourceFactory.set(Resource.EQUIPMENTS, EquipmentResource);
        this.resourceFactory.set(Resource.HANDHELD_PROFILES, HandheldProfileResource);
        this.resourceFactory.set(Resource.ORGANISATIONS, OrganisationResource);
        this.resourceFactory.set(Resource.FUEL_SURCHARGE_GROUPS, FuelSurchargeGroupResource);
        this.resourceFactory.set(Resource.PURCHASE_ORDERS, PurchaseOrderResource);
        this.resourceFactory.set(Resource.IN_CGST_RATES, CGSTCategoryResource);
        this.resourceFactory.set(Resource.IN_SGST_RATES, SGSTCategoryResource);
        this.resourceFactory.set(Resource.IN_IGST_RATES, IGSTCategoryResource);
        this.resourceFactory.set(Resource.VEHICLE_CHECKLISTS, VehicleCheckListResource);
        this.resourceFactory.set(Resource.STOCK_CHANGE_CONDITION, StockChangeConditionResource);
        this.resourceFactory.set(Resource.RESTORES, RestoreResource);
        this.resourceFactory.set(Resource.BACKUPS, BackupResource);
        this.resourceFactory.set(Resource.EXECUTIONS, ExecutionResource);
        this.resourceFactory.set(Resource.USERS, UserResource);
        this.resourceFactory.set(Resource.SHORTFALL_REPORT, ShortfallReportResource);
        this.resourceFactory.set(Resource.PRODUCT_COST_CHANGES, ProductCostChangeResource);
        this.resourceFactory.set(Resource.SURVEY_REPORT, SurveyReportResource);
        this.resourceFactory.set(Resource.GCT_RATES, GctTaxCategoryResource);
        this.resourceFactory.set(Resource.SITE_VISIT_SKIP_REASONS, SiteVisitSkipReasonsResource);
        this.resourceFactory.set(Resource.ASYNC_REQUESTS, AsyncRequestResource);
        this.resourceFactory.set(Resource.BRANCH_PAYMENTS, BranchPaymentResource);
        this.resourceFactory.set(Resource.BRANCH_TRANSACTIONS, BranchTransactionResource);
        this.resourceFactory.set(Resource.PURCHASE_PAYMENTS, PurchasePaymentResource);
        this.resourceFactory.set(Resource.PURCHASE_CREDIT_NOTES, PurchaseCreditNoteResource);
        this.resourceFactory.set(Resource.CREDIT_NOTES, CreditNoteResource);
        this.resourceFactory.set(Resource.CATALOGUES, CatalogueResource);
        this.resourceFactory.set(Resource.PRESENTATIONS, PresentationResource);
        this.resourceFactory.set(Resource.RESOURCE_ITEMS, CatalogueResourceItemResource);
        this.resourceFactory.set(Resource.RESOURCE_GROUPS, CatalogueResourceGroupResource);
        this.resourceFactory.set(Resource.SUPPLIER_PAYMENT_TERMS, SupplierPaymentTermResource);
        this.resourceFactory.set(Resource.EXPENSE_PAYMENT_METHOD, ExpensePaymentMethodResource);
        this.resourceFactory.set(Resource.EXPENSE_TYPES, ExpenseTypeResource);
        this.resourceFactory.set(Resource.EMPLOYEE_EXPENSES, EmployeeExpenseResource);
        this.resourceFactory.set(Resource.BRANDS, BrandResource);
        this.resourceFactory.set(Resource.INTEGRATION_MAPPINGS, IntegrationMappingResource);
        this.resourceFactory.set(Resource.BIN_TYPES, BinTypeResource);
        this.resourceFactory.set(Resource.BINS, BinResource);
        this.resourceFactory.set(Resource.INVOICES, InvoiceResource);
        this.resourceFactory.set(Resource.CUSTOM_PDF_TEMPLATES, CustomPdfTemplateResource);
        this.resourceFactory.set(Resource.SUPPLIER_GROUPS, SupplerGroupResource);
        this.resourceFactory.set(Resource.BUDGETS, BudgetResource);
        this.resourceFactory.set(Resource.WAREHOUSE_TRANSFERS, WarehouseTransferResource);
        this.resourceFactory.set(Resource.STANDING_ORDERS, StandingOrderResource);
        this.resourceFactory.set(Resource.STANDING_LOAD_ORDERS, StandingLoadOrderResource);
        this.resourceFactory.set(Resource.PRODUCT_ATTRIBUTE_WHITELIST, AttributeWhitelistResource);
        this.resourceFactory.set(Resource.TERRITORIES, TerritoryResource);
    }

    public getResource(resource: any) {
        if (!resource || !this.resourceFactory.has(resource)) {
            return null;
        }
        return this._injector.get(this.resourceFactory.get(resource));
    }
}
